import {ACTION_SET_CATEGORIES} from '../actions/categories';

const DEFAULT_STATE = [];

export default function categoriesReducer(state, action) {
    if (!state) {
        state = DEFAULT_STATE;
    }

    switch (action.type) {
        case ACTION_SET_CATEGORIES:
            state = [...action.categories];
            break;
    }

    return state;
}
